export default "__VITE_ASSET__oFmSmRDB__"